<template>
  <div>
    <!-- 表格有数据 -->
    <div class="hasData" v-if="isShow">
      <el-table
        ref="multipleTable"
        empty-text=" "
        v-loading="loading"
        :data="list"
        stripe
        :row-class-name="TableRow"
        :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
        :cell-style="{ color: '#666666' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="农场名称" prop="farmName" />
        <el-table-column
          label="农事类型"
          prop="sysMissionCategoryName"
          width="90"
        />
        <el-table-column label="地块" prop="landInfo">
          <template slot-scope="scope">
            <el-tooltip
              raw-content
              placement="top-start"
              v-if="scope.row.landInfo"
            >
              <div slot="content" style="width: 250px; text-align: center">
                {{ scope.row.landInfo }}
              </div>
              <span class="table-txt">
                {{ scope.row.landInfo }}
              </span>
            </el-tooltip>
            <span v-else>{{ scope.row.landInfo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="农资">
          <template slot-scope="scope">
            <el-tooltip
              raw-content
              placement="top-start"
              v-if="!(!scope.row.agriList || !scope.row.agriList.length)"
            >
              <div slot="content" style="width: 250px; text-align: center">
                {{ scope.row | formatArgic }}
              </div>
              <span class="table-txt">
                {{ scope.row | formatArgic }}
              </span>
            </el-tooltip>
            <span v-else>{{ scope.row | formatArgic }}</span>
          </template>
        </el-table-column>
        <el-table-column label="作业方式" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.operationMode === 0 ? "人工" : "机械" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="农事操作时间" prop="completeTime" width="120" />
        <el-table-column label="农事创建时间" prop="createTime" width="120" />
        <el-table-column label="自动审核通过时间" width="150">
          <template slot-scope="scope">
            <div class="date-icon">
              <span>{{
                scope.row.taskTime || "--" | formatDate("yyyy-MM-dd")
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div class="date-icon">
              <span v-if="scope.row.auditStatus === 2" class="err-txt"
                >设置失败</span
              >
              <span v-if="scope.row.auditStatus === 0">{{
                scope.row.taskTime ? "已设置" : "未设置"
              }}</span>
              <span v-if="scope.row.auditStatus === 1">设置成功</span>
              <el-tooltip
                v-if="scope.row.auditStatus === 2"
                class=""
                effect="dark"
                content="当前数据自动审核失败，请手动重新审核。"
                placement="top"
              >
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作人"
          prop="chargeUserName"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <span
              class="operate-btn"
              v-if="isShowEdit"
              @click="editFarming(scope.row.id, scope.row.categoryType)"
              ><i class="el-icon-edit"></i
            ></span>
            <span
              class="operate-btn"
              v-if="isShowDel"
              @click="deleteData(scope.row.id)"
              ><i class="el-icon-delete"></i
            ></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 表格无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/aviatFarmingList/batch-nodata.png" alt="" />
      </div>
      <p style="color: #333; margin-bottom: 20px">暂无待审核数据</p>
      <el-button size="medium" type="primary" @click="goArigicRecordPage"
        >农事记录</el-button
      >
    </div>
  </div>
</template>

<script>
import sameIn from "@/mixins/listsdetails.js";
import { mapActions } from "vuex";
// import { windowHref } from "@/utils/index";
import { getDel } from "@/api/request/snkd.produce";

export default {
  name: "TableList",
  mixins: [sameIn],
  data() {
    return {
      //是否显示编辑按钮
      isShowEdit: false,
      //是否显示删除按钮
      isShowDel: false,
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    formatArgic(val) {
      if (!val.agriList || !val.agriList.length) {
        return "--";
      } else {
        let data = val.agriList[0];
        return (
          data.agriResName + " " + data.dose + " " + data.agriResMeterUnitName
        );
      }
    },
  },
  async mounted() {
    await this.fnHasPermission();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    //判断按钮是否有权限
    async fnHasPermission() {
      //删除
      this.isShowDel = await this.hasPermission(
        "produce:navigateCultivate:del"
      );
      //编辑
      this.isShowEdit = await this.hasPermission(
        "produce:navigateCultivate:edit"
      );
    },
    editFarming(id, type) {
      this.$router.push({
        path: "/editFarming",
        query: {
          id: id,
          type: type,
        },
      });
    },
    deleteData(id) {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `是否确定删除此条数据？`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "删除后的数据将无法恢复。")]
          ),
        ]),
        type: "warning",
      })
        .then(async () => {
          await getDel({
            idList: [id],
          }).then((res) => {
            const { respCode } = res;
            if (respCode === 0) {
              this.$message({
                type: "success",
                message: "删除成功！",
              });
              this.$emit("updateList");
            }
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(rows) {
      console.log("handleSelectionChange", rows);
      this.$emit("selectListChange", rows);
    },
    goArigicRecordPage() {
      // windowHref("/home/batch", {
      //   companyId: this.companyId,
      //   farmId: this.farmId,
      //   tab: 1,
      //   periodType: 2,
      //   source: "hangyu",
      // });
      window.open(
        window.location.origin +
          `/index.html#/home/batch/company=${this.companyId}&farm=${this.farmId}&tab=1&periodType=2&source=hangyu`
      );
    },
  },
};
</script>

<style scoped lang="scss">
.hasData {
  height: 100%;
  padding: 12px;
  .operate-btn {
    display: inline-block;
    margin-right: 10px;
  }
  .date-icon {
    display: flex;
    align-items: center;
    .el-icon-warning {
      margin-left: 6px;
      font-size: 22px;
      color: #e6a23c;
    }
    .err-txt {
      color: red;
    }
  }
  ::v-deep .table-txt {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
}
</style>
